module.exports = __webpack_public_path__ + "imgs/concentrate.a4946f571caba2cc4e0439c518a5edd1.jpg";